<template>
  <v-container
    :style="
      cartItems.length || bundleItems.length || cartTreatments.length
        ? 'max-width: 1070px'
        : 'max-width: 500px'
    "
  >
    <v-row
      v-if="
        $wait.is(`loading clickAndCollect fetchCart`) &&
        !$wait.is(`loading clickAndCollect checkout`)
      "
      class="mt-10"
      justify="center"
    >
      <v-progress-circular indeterminate size="64" />
    </v-row>
    <div
      :style="{
        opacity:
          $wait.is(`loading clickAndCollect fetchCart`) &&
          !$wait.is(`loading clickAndCollect checkout`)
            ? 0
            : 1,
        height: !(cartItems.length || bundleItems.length || cartTreatments)
          ? '600px'
          : '',
      }"
    >
      <div
        v-if="$route.name === 'webshopChainShoppingCartClickAndCollect'"
        :style="{
          height: !(
            cartItems.length ||
            bundleItems.length ||
            cartTreatments.length
          )
            ? '600px'
            : '',
        }"
      >
        <div
          v-if="cartItems.length || bundleItems.length || cartTreatments.length"
        >
          <div class="d-flex justify-space-between align-center mb-5">
            <div class="font-weight-medium" style="font-size: 30px">
              Handlekurv
            </div>
            <!-- <v-icon color="primary" class="pr-3" @click="clearCart()"
              v-if="cartItems.length || bundleItems.length || cartTreatments.length">fxt-trash-alt</v-icon> -->
          </div>
          <div
            v-for="item in cartTreatments"
            :key="item.urlSafe"
            class="font-weight-medium"
          >
            <cart-treatment :cart-item="item" :siteId="cartSite">
            </cart-treatment>
          </div>
          <div
            v-for="item in cartItems"
            :key="item.id + item.isAdditionalProduct"
            class="font-weight-medium"
          >
            <cart-item
              :cart-item="item"
              :inCart="true"
              :unavailable="productNotAvailable(item)"
            >
            </cart-item>
          </div>
          <div
            v-for="item in bundleItems"
            :key="item.id"
            class="font-weight-medium"
          >
            <cart-bundle
              :cart-item="item"
              :inCart="true"
              :unavailable="bundleNotAvailable(item)"
            >
            </cart-bundle>
          </div>

          <hr
            class="mt-4"
            style="
              border-image: linear-gradient(
                  90deg,
                  var(--v-primary-base) 0%,
                  var(--v-primary-base) 51.04%,
                  var(--v-primary-base) 100%
                )
                1;
            "
          />
          <div
            class="d-flex justify-space-between align-center my-2"
            v-if="
              cartItems.length || bundleItems.length || cartTreatments.length
            "
          >
            <p class="ml-2 mb-0 total-price">Totalt før rabatter</p>
            <div>
              <v-col
                class="text-right d-flex flex-column pr-12"
                style="white-space: nowrap; justify-content: center"
              >
                <span
                  :style="{
                    'font-size': '16px',
                    'text-decoration': '',
                    'font-weight': '',
                  }"
                  >kr {{ totalWithoutDiscounts | currency(2, 2) }}</span
                >
              </v-col>
            </div>
          </div>
          <div
            class="d-flex justify-space-between align-center my-2"
            v-if="
              cartItems.length || bundleItems.length || cartTreatments.length
            "
          >
            <p class="ml-2 mb-0 total-price">Rabatter</p>
            <div>
              <v-col
                class="text-right d-flex flex-column pr-12"
                style="white-space: nowrap; justify-content: center"
              >
                <span
                  :style="{
                    'font-size': '16px',
                    'text-decoration': '',
                    'font-weight': '',
                  }"
                  >kr {{ totalDiscount | currency(2, 2) }}</span
                >
              </v-col>
            </div>
          </div>

          <div
            class="d-flex justify-space-between align-center my-2 price"
            v-if="
              cartItems.length || bundleItems.length || cartTreatments.length
            "
          >
            <p class="ml-2 mb-0 total-price">Sum totalt</p>
            <div>
              <v-col
                class="text-right d-flex flex-column pr-12"
                style="white-space: nowrap; justify-content: center"
              >
                <span
                  :style="{
                    'font-size': '16px',
                    'text-decoration': '',
                    'font-weight': '',
                  }"
                  >kr {{ totalCartPrice | currency(2, 2) }}</span
                >
              </v-col>
            </div>
          </div>
        </div>
        <div
          v-else
          class="d-flex flex-column justify-center"
          style="height: 100%"
        >
          <div class="d-flex flex-column align-center">
            <div class="mb-6">
              <div class="mask-skew">
                <div class="art-skew">
                  <img
                    width="174px"
                    color="primary"
                    src="../../../assets/img/fxt_cart_illustration.svg"
                  />
                </div>
              </div>
            </div>
            <p class="cart__empty text-center pb-12">Handlekurven er tom.</p>
          </div>

          <div class="">
            <v-btn block color="primary" rounded outlined @click="home">
              Gå til nettbutikk
            </v-btn>
          </div>
        </div>
      </div>

      <div
        v-if="webshopPaused && nextActionButtonText === 'Send bestilling'"
        class="pt-4"
        cols="12"
      >
        <v-alert
          border="bottom"
          color="primary"
          colored-border
          elevation="5"
          type="warning"
        >
          Nettbutikken er midlertidig ute av drift. Du kan se på produktene, men
          det er ikke mulig å bestille varer!
        </v-alert>
      </div>
      <div v-if="!salonPool.length" class="pt-4" cols="12">
        <v-alert
          border="bottom"
          color="primary"
          colored-border
          elevation="5"
          type="warning"
          >Dessverre kan ingen av avdelingene tilby alle de valgte produktene i
          en bestilling.</v-alert
        >
      </div>
      <v-row class="mt-8">
        <v-col
          class="pr-2"
          v-if="$route.name !== 'webshopChainCheckoutCompletedClickAndCollect'"
        >
        </v-col>
        <v-col
          v-if="
            $route.name !== 'webshopChainCheckoutCompletedClickAndCollect' &&
            (cartItems.length || bundleItems.length || cartTreatments.length)
          "
          class="pl-2"
        >
          <v-btn
            :disabled="
              (!this.webshopSettings.active &&
                this.webshopSettings.activatedSalons.length) ||
              nextActionButtonDisabled
            "
            :loading="$wait.is('loading clickAndCollect checkout')"
            block
            color="primary"
            rounded
            @click="nextButtonAction"
          >
            {{ nextActionButtonText }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <RecommendationBox
      v-if="cartItemIds.length > 0"
      class="rec-box-add-dialog mt-4"
      :userId="this.$user.onlineSluttKundeId"
      presentation="grid"
      :itemQty="4"
      :itemType="itemType.P"
      :chainId="parseInt(this.$route.params.chainId)"
      :location="location.CART"
      :channel="channel.Nettbutik"
      :productIds="base64Ids"
      :urlBase="urlBase"
      @buttonClick="addBtnAction"
      @cardClick="goToProductDetails"
      :cartItemsIds="cartItemIds"
    >
    </RecommendationBox>
  </v-container>
</template>

<script>
import webshopMixins from "@/components/webshop/cart/webshop.mixins";
import checkoutSteps from "./checkoutSteps";
import { mapWaitingActions } from "vue-wait";
import { cloneDeep } from "lodash-es";
import CartItem from "@/components/webshop/cart/CartItem.vue";
import CartBundle from "@/components/webshop/cart/CartBundle.vue";
import CartTreatment from "@/components/webshop/cart/CartTreatment.vue";
import RecommendationBox from "@fixit/v-recommendation-box";
import {
  ItemType,
  Location,
  Channel,
} from "@fixit/v-recommendation-box/src/enums";
import wrap from "@/utils/odin-guid/wrap";

export default {
  mixins: [webshopMixins],
  components: {
    CartItem,
    CartBundle,
    RecommendationBox,
    CartTreatment,
  },
  data() {
    return {
      processedItemsHeaders: [
        { text: "Produkt", value: "title", visible: true },
        { text: "Antall", align: "end", value: "price", visible: true },
        { text: "Pris", align: "end", value: "quantity", visible: true },
        { text: "Rabatt", align: "end", value: "rabatt", visible: true },
        { text: "Sum", align: "end", value: "sum", visible: true },
      ],
      checkoutDialog: false,
      thankYouDialog: false,
      checkoutSteps,
      selectedDeliveryOption: 1,
      loading: false,
      discounts: [],
      processOrderInProgressButtonIsClicked: false,
      totalCartPrice: 0,
      totalDiscount: 0,
      totalWithoutDiscounts: 0,
      itemType: ItemType,
      location: Location,
      channel: Channel,
    };
  },
  computed: {
    nextActionButtonDisabled() {
      return (
        (this.cartItems.length &&
          this.cartItems.filter((x) => this.productNotAvailable(x)).length ===
            this.cartItems.length) ||
        (this.bundleItems.length &&
          this.bundleItems.filter((x) => this.bundleNotAvailable(x)).length ===
            this.bundleItems.length) ||
        (this.webshopPaused &&
          this.nextActionButtonText === "Send bestilling") ||
        !(this.salonPool.length || this.cartTreatments.length) ||
        (this.cartTotalQuantity == 0 && this.cartTreatments.length == 0)
      );
    },
    base64Ids() {
      var array = [];
      if (this.cartItems.length) {
        this.cartItems.forEach((x) => array.push(x.base64Id));
      }
      if (this.cartBundles.length) {
        this.cartBundles.forEach((bundle) => {
          bundle.productIds.forEach((x) => array.push(wrap(x).Base64Guid));
        });
      }
      return array;
    },
    paymentTypes() {
      return this.$store.getters["clickAndCollect/get"]("paymentTypes");
    },

    paymentOptions() {
      return this.$store.getters["clickAndCollect/get"]("paymentOptions");
    },

    dataTableHeaders() {
      return this.processedItemsHeaders.filter((x) => x.visible === true);
    },

    checkoutPaymentType: {
      get() {
        return this.$store.getters["clickAndCollect/get"](
          "checkoutPaymentType"
        );
      },

      set(value) {
        this.$store.dispatch("clickAndCollect/set", {
          key: "checkoutPaymentType",
          value,
        });
      },
    },

    checkoutPaymentOption: {
      get() {
        return this.$store.getters["clickAndCollect/get"](
          "checkoutPaymentOption"
        );
      },

      set(value) {
        this.$store.dispatch("clickAndCollect/set", {
          key: "checkoutPaymentOption",
          value,
        });
      },
    },

    productNotAvailable() {
      return (item) => {
        return (
          !item.quantity ||
          !(this.cartProducts.find((x) => x.id === item.id).quantity || 0)
        );
      };
    },

    bundleNotAvailable() {
      return (bundle) => {
        return (
          !bundle.quantity ||
          this.getCartBundleStockAmountForSite(
            bundle,
            parseInt(this.$store.getters["checkout/salonPool"][0] || 0)
          ) == 0
        );
      };
    },

    minutesTextFormat() {
      return (val) => {
        if (val >= 1440) {
          let days = Math.round(val / 1440);
          return `${days} ${days <= 1 ? "dag" : "dager"}`;
        } else if (val >= 60) {
          let hours = Math.round(val / 60);
          return `${hours} ${hours <= 1 ? "time" : "timer"}`;
        } else {
          let hours = Math.round(val);
          return `${hours} ${hours <= 1 ? "minutt" : "minutter"}`;
        }
      };
    },

    previousActionButtonText() {
      switch (this.$route.name) {
        case "webshopChainCheckoutClickAndCollect":
          return "Fortsett å handle";
        case "webshopChainCheckoutClickAndCollectOrderPreview":
          return "Tilbake";
        default:
          return "Fortsett å handle";
      }
    },

    nextActionButtonText() {
      switch (this.$route.name) {
        case "webshopChainCheckoutClickAndCollect":
          return "Gå til kassen";
        case "webshopChainCheckoutClickAndCollectOrderPreview":
          return "Send bestilling";
        default:
          return "Gå til kassen";
      }
    },

    selectedSalon() {
      return this.salons.find((x) => x.siteId == this.$route.params.siteId);
    },

    cartTotalQuantity() {
      /** use discounts from item */

      var productTotalQuantity = this.productsAvailableForCheckout.reduce(
        (total, product) => {
          return total + product.quantity;
        },
        0
      );

      var bundleTotalQuantity = this.bundlesAvailableForCheckout.reduce(
        (total, bundle) => {
          return total + bundle.quantity;
        },
        0
      );

      return productTotalQuantity + bundleTotalQuantity;
    },

    cartTotalDiscountPrice() {
      /** use discounts from item */
      var someObj = [];
      this.productsAvailableForCheckout.forEach((prod) => {
        if (prod.discounts.length) {
          for (var i in prod.discounts) {
            someObj.push(
              (prod.price - prod.discounts[i].discountPrice) *
                prod.discounts[i].quantity
            );
          }
        }
      });
      var reducedList = someObj.reduce((a, b) => {
        return a + b;
      });

      if (reducedList) {
        return reducedList;
      }

      return 0;
    },

    totalBundleDiscounts() {
      /** use discounts from item */

      if (this.bundlesAvailableForCheckout.length) {
        var bundlePrice = this.bundlesAvailableForCheckout.reduce(
          (total, bundle) => {
            return total + bundle.campaignValue * bundle.quantity;
          },
          0
        );

        var bundleOriginalPrice = this.bundlesAvailableForCheckout.reduce(
          (total, bundle) => {
            return total + bundle.totalValue * bundle.quantity;
          },
          0
        );

        return bundleOriginalPrice - bundlePrice;
      }
      return 0;
    },

    cartTotalPrice() {
      /** use discounts from item */
      var productTotal = this.productsAvailableForCheckout.reduce(
        (total, product) => {
          return total + this.itemDiscount(product).salePrice;
        },
        0
      );
      var bundleTotal = this.bundlesAvailableForCheckout.reduce(
        (total, bundle) => {
          return total + bundle.campaignValue * bundle.quantity;
        },
        0
      );

      return productTotal + bundleTotal;
    },

    cartTotalPriceWithoutDiscount() {
      var bundleTotal = this.bundlesAvailableForCheckout.reduce(
        (total, bundle) => {
          return total + bundle.totalValue * bundle.quantity;
        },
        0
      );
      return (
        this.productsAvailableForCheckout.reduce((total, product) => {
          return total + product.price * product.quantity;
        }, 0) + bundleTotal
      );
    },
    productsAvailableForCheckout() {
      return this.cartItems.filter((p) => !this.productNotAvailable(p));
    },
    bundlesAvailableForCheckout() {
      return this.bundleItems.filter((x) =>
        this.isDateAfterToday(new Date(x.campaignDateTo))
      );
    },

    cartProductsAndBundles() {
      return this.cartItems.concat(
        this.bundleItems.filter((x) =>
          this.isDateAfterToday(new Date(x.campaignDateTo))
        )
      );
    },

    bundleItems() {
      return this.cartBundles;
    },

    fetchedDiscounts: {
      get() {
        return this.discounts;
      },
      set(value) {
        this.discounts = value;
      },
    },
  },
  methods: {
    ...mapWaitingActions("checkout", {
      getShoppingCart: "loading clickAndCollect fetchCart",
    }),

    isDateAfterToday(date) {
      return (
        new Date(date.toDateString()) >= new Date(new Date().toDateString())
      );
    },
    getCartBundleStockAmountForSite(bundle, siteId) {
      return bundle.subscriptionsList.find((x) => x.siteId === siteId)
        ?.maximumProductsSold === 0
        ? -1
        : bundle.subscriptionsList.find((x) => x.siteId === siteId)
            ?.maximumProductsSold -
            bundle.subscriptionsList.find((x) => x.siteId === siteId)
              ?.currentNumberOfProductsSold || 0;
    },

    hasDiscount(item) {
      return this.discounts.find((x) => x.ProductId === item.id);
    },

    isDiscountValid(item) {
      return item && item.DiscountPrice != item.OriginalPrice;
    },
    findDiscount(product) {
      /** use discounts from item */
      var discountPrice = 0;
      if (this.discounts) {
        var discount = this.discounts.find(
          (x) =>
            x.ProductId === product.id &&
            x.Freebied == product.isAdditionalProduct
        );
        discountPrice =
          discount !== undefined
            ? discount.OriginalPrice - discount.DiscountPrice
            : 0;
      }
      return discountPrice;
    },

    async checkIfCartProductsChanged() {
      let prevCart = cloneDeep(this.cartItems);
      await this.getShoppingCart({
        chainId: this.$route.params.chainId || this.$route.query.chainId,
      });
      let newCart = cloneDeep(this.cartItems);
      return (
        newCart.length !== prevCart.length ||
        !!newCart.filter(
          (c) =>
            this.productNotAvailable(c) !==
            this.productNotAvailable(prevCart.find((pc) => pc.id === c.id))
        ).length
      );
    },

    previousButtonAction() {
      /**does not exist anymore */
    },

    async nextButtonAction() {
      window.location.href = `${process.env.VUE_APP_FIXIT_NO_URL}/checkout/${
        this.$route.params.chainId || this.$route.query.chainId
      }?source=nettbutikk`;
    },

    closeCheckoutDialog(checkoutCompleted) {
      this.checkoutDialog = false;
      this.thankYouDialog = checkoutCompleted;
    },
    userLoggedInCallback() {
      // Proceed to the checkout if logged in successfull
      if (
        this.processOrderInProgressButtonIsClicked &&
        this.$route.name == "webshopChainCheckoutClickAndCollect"
      ) {
        this.nextButtonAction();
        this.processOrderInProgressButtonIsClicked = false;
      }
    },
    itemDiscount(item) {
      var salePrice = item.price;
      var totalPriceForQuantity = 0;
      var discountedQuantity = 0;
      if (item.discounts.length) {
        item.discounts.forEach((discount) => {
          totalPriceForQuantity += discount.discountPrice * discount.quantity;
          discountedQuantity += discount.quantity;
        });
      }
      if (discountedQuantity <= item.quantity && discountedQuantity > 0) {
        totalPriceForQuantity +=
          item.price * (item.quantity - discountedQuantity);

        salePrice = totalPriceForQuantity / (item.quantity + discountedQuantity);
      }

      return {
        salePrice: salePrice,
        price: item.price,
        totalSalePrice: totalPriceForQuantity,
        totalValue: item.price * item.quantity,
        discounted: discountedQuantity > 0,
      };
    },
    calculateTotalPrice() {
      let productsPrice = 0;
      if (this.productsAvailableForCheckout) {
        this.productsAvailableForCheckout.length
          ? this.productsAvailableForCheckout.forEach((x) => {
              this.itemDiscount(x).discounted
                ? (productsPrice += this.itemDiscount(x).totalSalePrice)
                : (productsPrice += x.price * x.quantity);
            })
          : 0;
      }
      if (this.bundlesAvailableForCheckout) {
        this.bundlesAvailableForCheckout.length
          ? this.bundlesAvailableForCheckout.forEach((x) => {
              x.campaignValue < x.totalValue
                ? (productsPrice += x.campaignValue * x.quantity)
                : (productsPrice += x.totalValue * x.quantity);
            })
          : 0;
      }

      if (this.cartTreatments) {
        this.cartTreatments.length
          ? (productsPrice += this.cartTreatments
              .map(
                (x) =>
                  x.pricePerSite.find((y) => y.siteId === this.cartSite)?.price
              )
              .reduce((partialSum, a) => partialSum + a, 0))
          : 0;
      }
      this.totalCartPrice = productsPrice;
    },

    calculateTotalDiscounts() {
      this.totalDiscount = 0; //reset total discounts before adding again
      if (this.productsAvailableForCheckout) {
        const discountAmounts = this.productsAvailableForCheckout.map((x) => {
          const discount = this.itemDiscount(x);
          if (discount.discounted) {
            return discount.totalValue - discount.totalSalePrice;
          } else {
            return 0;
          }
        });
        if (discountAmounts.length) {
          this.totalDiscount += discountAmounts.reduce((total, x) => total + x);
        }
      }
      if (this.bundlesAvailableForCheckout) {
        const bundleDiscountAmounts = this.bundlesAvailableForCheckout.map(
          (x) => {
            if (x.campaignValue < x.totalValue) {
              return (x.totalValue - x.campaignValue) * x.quantity;
            } else {
              return 0;
            }
          }
        );
        if (bundleDiscountAmounts.length) {
          this.totalDiscount += bundleDiscountAmounts.reduce(
            (total, x) => total + x
          );
        }
      }
    },

    calculatePrices() {
      this.calculateTotalDiscounts();
      this.calculateTotalPrice();
      this.totalWithoutDiscounts = this.totalCartPrice + this.totalDiscount;
    },
    home() {
      this.$router
        .replace({
          name: "webshopChain",
          params: { chainId: this.currentChainId },
        })
        .catch(() => {});
    },
    async addBtnAction(item) {
      var link = item.urlSafe.split("/");
      var product = await this.$store.dispatch("webshop/getProductsByIds", {
        avoidCache: true,
        chainId: parseInt(this.$route.params.chainId),
        includeCampaignProducts: true,
        isBase64: true,
        productIds: [link[1]],
      });
      this.$store.dispatch("webshop/set", {
        key: "addedToCartDialog",
        value: false,
      });
      this.$store.dispatch("webshop/set", {
        key: "selectedProduct",
        value: product[0],
      });
      this.addProductToSalonCart(this.salons[0]);
    },
    goToProductDetails(item) {
      var link = item.urlSafe.split("/");
      this.$router
        .push({
          name: "webshopChainProductDetails",
          params: {
            productTitle: link[0],
            productId: link[1],
          },
        })
        .catch(() => {});
    },
  },
  watch: {
    "$route.name"(val) {
      if (val === "webshopChainCheckoutClickAndCollect")
        this.getShoppingCart({
          chainId: this.$route.params.chainId || this.$route.query.chainId,
        });
    },
    "$route.params.chainId"(val, oval) {
      if (oval != val && !!val)
        this.getShoppingCart({
          chainId: val,
        });
    },
    cartItems() {
      this.calculatePrices();
    },
  },
  async created() {
    // Listen for successfull login or profile created
    this.$eventBus.$on("user-logged-in", this.userLoggedInCallback);
    await this.getShoppingCart({
      chainId: this.$route.params.chainId || this.$route.query.chainId,
    });
  },

  mounted() {
    this.calculatePrices();
  },
  destroyed() {
    this.thankYouDialog = false;
  },
};
</script>

<style lang="scss" scoped>
.cart {
  &__empty {
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
  }
}

.mask-skew {
  background: #579fa71f;
  width: 275px;
  height: 182px;
  transform: skewY(-15deg);
}

.art-skew {
  transform: skewY(15deg);
  position: relative;
  left: 16%;
  top: 10%;
}

.product__unavailable div:not(:nth-last-child(1)) {
  opacity: 0.5;
}

.checkout__confirm::v-deep {
  .v-data-table-header {
    background-color: #d9e1e7;
  }

  tr:not(:nth-last-child(2)) {
    td {
      border-bottom: none !important;
    }
  }

  tr:last-child {
    td {
      border-bottom: thin solid rgba(0, 0, 0, 0.12) !important;
    }
  }

  td {
    height: 35px;
  }

  th,
  td {
    font-size: 16px;
  }

  th {
    color: black !important;
  }
}

.price {
  background-color: #f8efe8;
  color: var(--v-primary-opacity-80);
  font-weight: bold;
}

.quantity__actions {
  padding: 12px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-items: center;

  .v-icon {
    cursor: pointer;
  }

  .v-icon::after {
    background-color: transparent;
  }
}
</style>
